import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { styles } from './styles'
import BounceLoader from '../../BounceLoader'

export const ConfirmationModal = ({
  title,
  text,
  returnText,
  submitText,
  onClose,
  onSubmit,
  loading = false,
}) => {
  const useStyles = makeStyles(styles)
  const classes = useStyles()

  return (
    <div className={classes.modalOverlay} onClick={onClose}>
      <div className={classes.modalContent} onClick={e => e.stopPropagation()}>
        <h2>{title}</h2>
        <p>{text}</p>
        <div className={classes.buttonRow}>
          <button onClick={onClose} className={classes.cancelButton}>
            {returnText}
          </button>
          <button
            onClick={onSubmit}
            className={classes.confirmButton}
            disabled={loading}
          >
            {loading ? <BounceLoader /> : submitText}
          </button>
        </div>
      </div>
    </div>
  )
}
